import { render, staticRenderFns } from "./house-header.vue?vue&type=template&id=50651800&scoped=true&"
import script from "./house-header.vue?vue&type=script&lang=js&"
export * from "./house-header.vue?vue&type=script&lang=js&"
import style0 from "./house-header.vue?vue&type=style&index=0&id=50651800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50651800",
  null
  
)

export default component.exports